// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{padding-top:0 !important}.unified-platform-header-container .ant-affix{z-index:100;position:relative}.header__xl{padding-right:10px}\n", ""]);
// Exports
module.exports = exports;
